import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box, Select, MenuItem, Typography, CircularProgress, TablePagination, Divider } from '@mui/material';

import { url } from 'src/apiUtils/apiPath';

import { appApi } from 'src/apiUtils/AppApi';
import { alpha, styled } from '@mui/material/styles';
// components
import { PieChart } from '@mui/x-charts/PieChart';



// ----------------------------------------------------------------------

AppWebsiteVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  pieDataList: PropTypes.array.isRequired,
};

export default function AppWebsiteVisits({ title, subheader, chartLabels, chartData, pieDataList = [], borderColor = 'primary', ...other }) {

  return (
    <Card sx={{
      paddingLeft: 1,
      paddingRight: 1,
      paddingBottom: 1,
      height: 306,
      // boxShadow: (theme) => `${alpha(theme.palette[borderColor].dark, 0.07)} 0px 7px 29px 0px`,
      border: (theme) => `1px solid ${alpha(theme.palette[borderColor].dark, 0.24)}`
    }}>
      <Box sx={{
        display: 'flex',
        justifyContent: "center",
        marginBottom: 2,
        color: (theme) => theme.palette[borderColor].dark,
      }}>
        <CardHeader title={title} subheader={subheader} />
      </Box>
      {pieDataList && pieDataList.length > 0 ?
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: 13 }}>
          <PieChart
            series={[
              {
                data: pieDataList,
                // [
                //   { id: 0, value: 10, label: 'Raj' },
                //   { id: 1, value: 15, label: 'Veera' },
                //   { id: 2, value: 20, label: 'Afsal' },
                //   { id: 3, value: 30, label: 'Mani' },
                //   { id: 4, value: 10, label: 'Raj' },
                //   { id: 5, value: 15, label: 'Veera' },
                //   { id: 6, value: 20, label: 'Afsal' },
                //   { id: 7, value: 30, label: 'Mani' },
                // ],
                innerRadius: 45,
                outerRadius: 100,
                paddingAngle: 3,
                cornerRadius: 5,
                startAngle: -180,
                endAngle: 180,
              },
            ]}
            width={300}
            height={200}
            legend={{ hidden: true }}
          />
        </Box> :

        <Box display={"flex"} justifyContent={"center"} alignContent={'center'} sx={{ padding: 4 }}>
          <Typography sx={{ color: 'red' }}>No Bookings Found</Typography>
        </Box>}
    </Card >
  );
}